import { render } from "./LogicalMemoryAnna.vue?vue&type=template&id=4fea7986&scoped=true"
import script from "./LogicalMemoryAnna.vue?vue&type=script&lang=js"
export * from "./LogicalMemoryAnna.vue?vue&type=script&lang=js"

import "./LogicalMemoryAnna.vue?vue&type=style&index=0&id=4fea7986&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fea7986"]])

export default __exports__